"use client";

import { useIsSandbox } from "@repo/utils/hooks/useIsSandbox";

export const SandboxBanner = () => {
  const isSandbox = useIsSandbox();
  if (!isSandbox) {
    return null;
  }
  return (
    <div className="sticky top-0 text-center h-8 flex items-center justify-center bg-[#CC4E00] text-white z-60">
      Sandbox Mode
    </div>
  );
};
